import * as React from "react";
import * as ReactDOM from "react-dom";

import {FComponent} from "@Common/react/f-component";

interface P {
    next: (width: number) => JSX.Element;
}
interface S {
    width: number;
}

export class WidthByWindow extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            width: props.translate(props.getInitWidth()),
        };
        this.domRef = React.createRef();
        this.listener = this.listener.bind(this);
    }

    componentDidMount() {
        this.mounted = true;
        
        this.updateWidth();

        window.addEventListener("resize", this.listener);

        this.checkWidthPeriodically();
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener("resize", this.listener);
        clearTimeout(this.timeoutId);
    }

    listener() {
        if (this.mounted) {
            this.updateWidth();
        }
    }

    checkWidthPeriodically() {
        if (this.mounted) {
            this.updateWidth();
            this.timeoutId = setTimeout(() => this.checkWidthPeriodically(), 1500);
        }
    }

    updateWidth() {
        const domNode = this.domRef.current;
        if (domNode) {
            const newWidth = this.props.translate(domNode.getBoundingClientRect().width);
            if (newWidth !== this.state.width) {
                this.setState({ width: newWidth });
            }
        }
    }
    
    render() {
        const {next} = this.props;
        const {width} = this.state;

        return (
            <div ref={this.domRef}>
                {next(width)}
            </div>
        );
    }
}